import React from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import './RatecartDialog.css';

function RatecartDialog() {
    return (
        <div className="ratecart-dialog">
            <h2 className='rate_heading'>AI Service Rates</h2>
            <Table className="custom-table rates_table">
                <TableHead>
                    <TableRow>
                        <TableCell className="header-cell">Ai Service</TableCell>
                        <TableCell className="header-cell">Model</TableCell>
                        <TableCell colSpan={2} className="header-cell">Cost</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell className="data-cell" rowSpan={2}>Google Service BARD</TableCell>
                        <TableCell className="data-cell" rowSpan={2}>chatbot_model_new</TableCell>
                        <TableCell className="data-cell">Input Data</TableCell>
                        <TableCell className="data-cell">$0.00025/1k chraracters</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="data-cell">Output Data</TableCell>
                        <TableCell className="data-cell">$0.0005/1k chraracters</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="data-cell" rowSpan={2}>Open AI</TableCell>
                        <TableCell className="data-cell" rowSpan={2}>Chat GPT-4</TableCell>
                        <TableCell className="data-cell">Input Data</TableCell>
                        <TableCell className="data-cell">$0.03/1k tokens</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="data-cell">Output Data</TableCell>
                        <TableCell className="data-cell">$0.06/1k tokens</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <h2 className='rate_heading Charges_heading'>Service Charges</h2>

            <Table className="custom-table rates_table">
                <TableHead>
                    <TableRow>
                        <TableCell className="Service_header-cell"> Service Name</TableCell>
                        <TableCell className="Service_header-cell">Costs</TableCell>
                        <TableCell colSpan={2} className="Service_header-cell">Units</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell className="Service_data-cell">Google Service </TableCell>
                        <TableCell className="Service_data-cell" >$0.004934021</TableCell>
                        <TableCell className="Service_data-cell">Characters</TableCell>
                     
                    </TableRow>
                  
                    <TableRow>
                        <TableCell className="data-cell" >Open AI Service</TableCell>
                        <TableCell className="data-cell" >$0.0129518</TableCell>
                        <TableCell className="data-cell">Tokens</TableCell>
                       
                    </TableRow>
                   
                </TableBody>
            </Table>

        </div>
    );
}

export default RatecartDialog;
